export default __webpack_public_path__ + "static/media/6.9ae07705.jpg";